import React from 'react';
import { useClubCacheManager } from '@/features/clubs/hooks';

/**
 * Component that manages club cache based on current route
 * This component should be included in the main app to handle cache invalidation
 */
const ClubCacheManager: React.FC = () => {
  useClubCacheManager();
  return null; // This component doesn't render anything
};

export default ClubCacheManager;
